import { usePermanent } from "@suse-o11y/use-permanent";
import Konva from "konva";
import React from "react";

import { Shape, type ShapeConfig } from "./Shape";

export interface RectConfig extends ShapeConfig, Pick<Konva.RectConfig, "cornerRadius"> {}

export type RectProps = RectConfig;

export const Rect: React.FC<RectProps> = (config) => {
	const rect = usePermanent(() => new Konva.Rect(config));

	return <Shape instance={rect} {...config} />;
};
